import React from 'react';
import {
  submitFormCreate,
  submitFormUpdate,
  submitFormCreateAllOutlet,
} from 'actions/library/modifier';
import { connect } from 'react-redux';
import * as clevertapLibraryModifier from 'clevertap/library/modifier';
import { getFormInitialValues } from 'redux-form';
import styles from './Detail.css';
import ModifierForm from './ModifierForm';

class Detail extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <ModifierForm onSubmit={this._onSubmit} />
      </div>
    );
  }

  _onSubmit = values => {
    const { dispatch, modifiers } = this.props;
    values.name = values.name ? values.name.trim() : '';
    values.options.forEach((opt, idx) => {
      values.options[idx].name = opt.name ? opt.name.trim() : '';
      values.options[idx].price = opt.price ? opt.price : '0';
    });
    if (values.id) {
      const prevName = this.props.initialModifier.name;
      const prevOptions = this.props.initialModifier.options;
      clevertapLibraryModifier.libraryModifierUpdateOneOutlet({
        prevName,
        prevOptions,
        newName: values.name,
        newOptions: values.options,
      });
      dispatch(submitFormUpdate(values.id, { modifier: values }, modifiers));
    } else if (values.action === 'save') {
      clevertapLibraryModifier.libraryModifierCreate({
        modifier: values,
        allOutlet: false,
      });
      dispatch(submitFormCreate({ modifier: values }, modifiers));
    } else {
      clevertapLibraryModifier.libraryModifierCreate({
        modifier: values,
        allOutlet: true,
      });
      dispatch(submitFormCreateAllOutlet({ modifier: values }, modifiers));
    }
  };
}

function mapStateToProps(state) {
  const { modifiers } = state.library.modifier;
  return {
    modifiers,
    initialModifier: getFormInitialValues('modifier')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Detail);
